import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { AccountService, FilesService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { ImageSizeEnum, User } from 'lingo2-models';
import { OnUiCover, OnUiCoverModule } from 'onclass-ui';

@Component({
  selector: 'app-author-info',
  standalone: true,
  imports: [CommonModule, OnUiCoverModule, RatingComponent, SubscribeComponent],
  templateUrl: './author-info.component.html',
  styleUrls: ['./author-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthorInfoComponent extends ChangableComponent {
  @Input() user: User;

  public cover(): OnUiCover {
    return {
      type: 'avatar',
      img: FilesService.getFileUrlBySize(this.user?.userpic_id, ImageSizeEnum.sm),
      link: AccountService.accountRoute(this.user).join('/'),
      form: 'circle',
    };
  }

  public fullName(): string {
    return AccountService.getUserFullName(this.user);
  }
}
